module.exports = __webpack_public_path__ + "img/LGBT.c1ac8ba7.png";